import { TermsUpdate } from './terms-update';

export interface UpdatedTermsStateModel {
  termsUpdates: TermsUpdate[];
  termsUpdatesInitialized: boolean;
}
